<template>
  <div id="pc">
    <el-container>
      <el-header height="36px">
        <vheader />
      </el-header>
      <el-divider></el-divider>
      <el-container>
        <el-aside width="200px">
          <navmenu></navmenu>
        </el-aside>
        <el-main>
          <router-view/>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import NavMenu from '@/components/NavMenu'
import Header from '@/components/Header'
export default {
  name: 'pc',
  components: {
    'navmenu': NavMenu,
    'vheader': Header
  }
}
</script>

<style>
#pc {
  margin-top: 0px;
}
.el-container{
  height: 100%;
}
.el-header {
  color: #fff;
  position: relative;
}
.el-aside{
  display: block;
  left: 0;
  margin-top: -24px;
  bottom: 0;
}
.el-main{
  position: absolute;
  left: 200px;
  right: 0;
  bottom: 0;
  top: 62px;
}
</style>



// WEBPACK FOOTER //
// src/PC.vue